import { useNavigate } from 'react-router'
import React from 'react'
import { trackButtonClick } from '@/utils/analytics'
import { getPropertyURL } from '@/utils/propertyNavigation'
import { markInternalNavigation } from '@/utils/attributionCapture'

const HistoryCard = ({data}) => {
  const navigate = useNavigate()


  return (
         <div key={data?.propertyId} className="row mb-3 pb-5 m-3">
                 <div className="col-2">
                   <img
                     src={
                       data?.propertyDetail?.defaultImagePath==="https://s3.amazonaws.com/hubzu-core-images-dev/frontend/images/no-photo.jpg"?"/assets/images/no-photo.jpg":data?.propertyDetail?.defaultImagePath
                     }
                     alt="image on the way"
                     className="my-offer-img cursor-pointer"
                     height={97}
                     width={145}
                     onClick={() => {
                       markInternalNavigation();
                       navigate(getPropertyURL(`/property/${data?.propertyDetail?.propertyId}`, data?.propertyDetail?.propertyCategory, data?.propertyDetail?.propertyStatus));
                       trackButtonClick({
                         eventName: "property_image_click",
                         eventCategory: "My Offers",
                         eventSource: "On property image click",
                         eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
                       })
                      }
                     }
                   />
                 </div>
                 <div className="my-offer-address-div col-8 py-3">
                   <a href={getPropertyURL(`/property/${data?.propertyDetail?.propertyId}`, data?.propertyDetail?.propertyCategory, data?.propertyDetail?.propertyStatus)}>
                     <p
                       className="my-offer-address-div-p p-0 m-0"
                       onClick={() => {
                         trackButtonClick({
                           eventName: "address_link_click",
                           eventCategory: "My Offers",
                           eventSource: "On property address click",
                           eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
                         })
                        }
                       }
                     >
                       {data?.propertyDetail?.propertyAddress?.streetNumber}{" "}
                       {data?.propertyDetail?.propertyAddress?.streetName}
                       {" , "}
                       {data?.propertyDetail?.propertyAddress?.city}
                       {" , "}
                       {data?.propertyDetail?.propertyAddress?.state}
                       {" , "}
                       {data?.propertyDetail?.propertyAddress?.zip}
                     </p>
                   </a>

                   <p className="my-offer-amount p-0 m-0">
                     My Latest Offer :{" "}
                     <span className="roboregular">
                       {new Intl.NumberFormat("en-US", {
                         style: "currency",
                         currency: "USD",
                         minimumFractionDigits: 0,
                         maximumFractionDigits: 0,
                       }).format(data?.activeOffer?.offerAmount)}
                     </span>
                   </p>

                 </div>
                 <div className="col-2">
                  <img src="/assets/images/pdp/property-notavailable.png" alt='Property not available' height="57px" width="78px"/>
                 </div>


               </div>
  )
}

export default HistoryCard